import { render, staticRenderFns } from "./AscAnserToolTemplate.vue?vue&type=template&id=081c2e40&scoped=true&"
import script from "./AscAnserToolTemplate.vue?vue&type=script&lang=js&"
export * from "./AscAnserToolTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscAnserToolTemplate.vue?vue&type=style&index=0&id=081c2e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c2e40",
  null
  
)

export default component.exports